import { render, staticRenderFns } from "./SaleView.vue?vue&type=template&id=3ad0b012&scoped=true"
import script from "./SaleView.vue?vue&type=script&lang=js"
export * from "./SaleView.vue?vue&type=script&lang=js"
import style0 from "./SaleView.vue?vue&type=style&index=0&id=3ad0b012&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad0b012",
  null
  
)

export default component.exports